/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.29",
    versionName: "0.4.0-nightly.2026.6.29",
    versionChannel: "nightly",
    buildDate: "2026-06-29T00:36:56.620Z",
    commitHash: "ca06dd85719a73ad1f5da3f4c5d8ed7d9ce7397a",
};
